<mat-form-field id="autoComplete-mat-form" [formGroup]="group" class="custom-form-field">
  <mat-label>{{ field.displayName }}</mat-label>
  <input
    type="text"
    aria-label="Number"
    matInput
    (keyup)="changeMyControl()"
    [formControlName]="field.name"
    [matAutocomplete]="auto"
    [name]="field.name"
    [required]="field?.isRequired"
    (focusout)="onInputBlur($event)"
  />
  <mat-autocomplete
    id="autoComplete-mat-auto"
    #auto="matAutocomplete"
    [displayWith]="displayFn"
    (optionSelected)="onOptionSelected($event)"
  >
    @for (item of filteredOptions; track item) {
      <mat-option id="autoComplete-mat-option" [value]="item">
        {{ item.value }}
      </mat-option>
    }
  </mat-autocomplete>

  @for (validation of field.validations; track validation) {
    <ng-container id="autoComplete-ngContain" ngProjectAs="mat-error">
      @if (group.get(field.name).hasError(validation.name)) {
        <mat-error id="autoComplete-mat-error{{ field.name }}">
          {{ validation.message }}
        </mat-error>
      }
    </ng-container>
  }
</mat-form-field>
